import store from "@/store";

// beforeRouteEnter guard of the satellite pages: they are available behind the "satellite" feature flag only.
// Checks the flags loaded from the API, not the localStorage copy the getter falls back to: on a fresh page load the
// copy may still belong to another user who used this browser.
export default async function satelliteFeatureGuard(to, from, next) {
  try {
    if (!store.state.user.featureFlags.length) {
      await store.dispatch("user/setFeatureFlags");
    }
  } catch (e) {
    // Treated as no access.
  }
  if (store.state.user.featureFlags.includes("satellite")) {
    next();
  } else {
    next({ name: "Dashboard" });
  }
}
